import React from "react";

const Search = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M15.8132 14.8533L11.8365 10.88C12.784 9.73333 13.3445 8.26667 13.3445 6.66667C13.3445 2.98667 10.3553 0 6.67223 0C2.98916 0 0 2.98667 0 6.66667C0 10.3467 2.98916 13.3333 6.67223 13.3333C8.27356 13.3333 9.74145 12.7733 10.8891 11.8267L14.8657 15.8C14.9992 15.9333 15.1726 16 15.3328 16C15.4929 16 15.6797 15.9333 15.7998 15.8C16.0667 15.5333 16.0667 15.12 15.7998 14.8533H15.8132ZM6.67223 11.9867C3.7231 11.9867 1.33445 9.6 1.33445 6.65333C1.33445 3.70667 3.7231 1.32 6.67223 1.32C9.62135 1.32 12.01 3.70667 12.01 6.65333C12.01 9.6 9.62135 11.9867 6.67223 11.9867Z"
        fill="black"
      />
    </svg>
  );
};

export default Search;
